import axios from 'axios';

// 文件上传返回结构（后端直接返回该对象，不包 ApiResult）
export interface UploadedFileInfo {
  fileName: string;
  originalName: string;
  mimetype: string;
  size: number;
  viewUrl: string;
}

// 专用于文件服务的 axios 实例
// 目前后端路径为 /api/file/api/xxx，这里设置 baseURL 为 /api/file
const fileAxios = axios.create({
  baseURL: '/api/file',
});

// 文件服务通用 GET（直接返回后端数据）
export async function fileGet<T>(url: string, params?: any): Promise<T> {
  const res = await fileAxios.get<T>(url, { params });
  return res.data as T;
}

// 文件服务通用 POST（直接返回后端数据）
export async function filePost<T>(url: string, data?: any): Promise<T> {
  const res = await fileAxios.post<T>(url, data);
  return res.data as T;
}

// ========== 示例接口，后续可以按需扩展 ==========

// 上传文件：请求路径 /api/file/api/upload，返回 UploadedFileInfo
export const uploadFile = (data: FormData): Promise<UploadedFileInfo> =>
  filePost<UploadedFileInfo>('/api/upload', data);

// 批量上传文件：请求路径 /api/file/api/upload-multiple，返回 UploadedFileInfo[]
export const uploadMultipleFiles = (files: FormData): Promise<UploadedFileInfo[]> =>
  filePost<UploadedFileInfo[]>('/api/upload-multiple', files);

// 示例：获取文件列表
export const fetchFileList = (params?: any): Promise<any[]> => fileGet<any[]>('/list', params);
